const BOOL_FIELDS = new Set([
  "lottracked",
  "serialtracked",
  "hazmat",
  "msdsRequired",
  "certificateRequired",
  "catchWeightFlag",
  "inboundCatchData",
  "outboundCatchData",
  "uomConversionAllowed",
  "decimalAllowed",
  "batchControlled",
  "expiryControlled",
  "reorderSafetyFlag",
  "fragileFlag",
  "qcRequired",
  "returnableFlag",
  "skuCodeUnique",
  "barcodeUnique",
]);

const NESTED_SOURCE_KEYS = [
  "header",
  "details",
  "itemDetails",
  "packaging",
  "uomDetails",
  "warehouse",
  "compliance",
  "merchandising",
  "wmsPayload",
  "wmsData",
  "skuData",
  "customerPricing",
  "attributes",
  "erp",
  "item",
];

/** API / WMS field names that map to a single form field (first match wins). */
const FIELD_SOURCES = {
  storerkey: ["storerkey", "owner", "storerKey", "storer_key"],
  sku: ["sku", "skuId", "sku_id", "itemCode", "item"],
  descr: ["descr", "description", "skuName", "itemName", "skuDescription"],
  packkey: ["packkey", "pack", "packKey"],
  stdcube: ["stdcube", "cube", "itemCube", "volume"],
  stdgrosswgt: ["stdgrosswgt", "grossWeight", "grosswgt", "gross_wgt"],
  stdnetwgt: ["stdnetwgt", "netWeight", "netwgt", "net_wgt", "itemWeight"],
  tareweight: ["tareweight", "tareWeight", "tare_weight"],
  toexpiredays: ["toexpiredays", "toExpireDays", "to_expire_days"],
  todeliverbydays: ["todeliverbydays", "toDeliverByDays", "to_deliver_by_days"],
  tobestbydays: ["tobestbydays", "toBestByDays", "to_best_by_days"],
  skufacilitygroup: ["skufacilitygroup", "skuFacilityGroup", "sku_facility_group"],
  skugroup: ["skugroup", "skuGroup", "sku_group", "stockCategory"],
  skugroup2: ["skugroup2", "skuGroup2", "sku_group2", "itemGroup"],
  class_: ["class_", "class", "itemClass"],
  freightClass: ["freightClass", "freight_class"],
  mateabilityCode: ["mateabilityCode", "mateability_code"],
  transportationMode: ["transportationMode", "transportation_mode"],
  equipmentAttribute: ["equipmentAttribute", "equipment_attribute"],
  equipmentType: ["equipmentType", "equipment_type"],
  equipmentLength: ["equipmentLength", "equipment_length"],
  department: ["department"],
  stockCategory: ["stockCategory", "stock_category"],
  country: ["country"],
  itemCharacteristics1: ["itemCharacteristics1", "item_characteristics1"],
  itemCharacteristics2: ["itemCharacteristics2", "item_characteristics2"],
  collection: ["collection"],
  theme: ["theme"],
  season: ["season"],
  style: ["style"],
  color: ["color", "colorCode"],
  size: ["size"],
  campaignStart: ["campaignStart", "campaign_start"],
  campaignEnd: ["campaignEnd", "campaign_end"],
  outboundAvgCaseWeight: ["outboundAvgCaseWeight", "outbound_avg_case_weight"],
  outboundTolerancePct: ["outboundTolerancePct", "outbound_tolerance_pct"],
  outboundTareWeight: ["outboundTareWeight", "outbound_tare_weight"],
  catchWeightWhen: ["catchWeightWhen", "catch_weight_when"],
  inboundAvgCaseWeight: ["inboundAvgCaseWeight", "inbound_avg_case_weight"],
  inboundTareWeight: ["inboundTareWeight", "inbound_tare_weight"],
  inboundTolerancePct: ["inboundTolerancePct", "inbound_tolerance_pct"],
  weightuom: ["weightuom", "weightUom", "weight_uom", "uom"],
  addwho: ["addwho", "addWho", "createdBy", "created_by"],
  shelflifeindicator: ["shelflifeindicator", "shelfLifeIndicator", "shelf_life_indicator"],
  lottracked: ["lottracked", "lotTracked", "lot_tracked"],
  serialtracked: ["serialtracked", "serialTracked", "serial_tracked"],
  hazmat: ["hazmat"],
  regulatoryCategory: ["regulatoryCategory", "regulatory_category"],
  vendorSkuReference: ["vendorSkuReference", "vendor_sku_reference"],
  msdsRequired: ["msdsRequired", "msds_required"],
  certificateRequired: ["certificateRequired", "certificate_required"],
  shortDescription: ["shortDescription", "short_description"],
  barcode: ["barcode", "gtin", "ean", "barCode"],
  alternateSkuCode: ["alternateSkuCode", "alternate_sku_code"],
  itemStatus: ["itemStatus", "item_status", "status"],
  itemType: ["itemType", "item_type"],
  categoryCode: ["categoryCode", "category_code", "category"],
  subCategoryCode: ["subCategoryCode", "sub_category_code", "subCategory"],
  subBrand: ["subBrand", "sub_brand"],
  variantType: ["variantType", "variant_type"],
  variantCode: ["variantCode", "variant_code"],
  tenantId: ["tenantId", "tenant_id"],
  organizationId: ["organizationId", "organization_id"],
  merchantHierarchyId: ["merchantHierarchyId", "merchant_hierarchy_id"],
  styleNumber: ["styleNumber", "style_number"],
  designReference: ["designReference", "design_reference"],
  colorCode: ["colorCode", "color_code"],
  sizeGroup: ["sizeGroup", "size_group"],
  material: ["material"],
  finish: ["finish"],
  productLine: ["productLine", "product_line"],
  launchDate: ["launchDate", "launch_date"],
  discontinueDate: ["discontinueDate", "discontinue_date"],
  hsnTaxCode: ["hsnTaxCode", "hsn_tax_code", "hsnCode"],
  salesUom: ["salesUom", "sales_uom", "uom"],
  pricingUom: ["pricingUom", "pricing_uom"],
  purchaseUom: ["purchaseUom", "purchase_uom"],
  inventoryUom: ["inventoryUom", "inventory_uom", "uom", "rfdefaultuom"],
  pieceUom: ["pieceUom", "piece_uom"],
  baseUom: ["baseUom", "base_uom", "uom", "rfdefaultuom", "inventoryUom"],
  innerPackUom: ["innerPackUom", "inner_pack_uom"],
  outerPackUom: ["outerPackUom", "outer_pack_uom"],
  palletUom: ["palletUom", "pallet_uom"],
  piecesPerInnerPack: ["piecesPerInnerPack", "pieces_per_inner_pack"],
  innerPacksPerOuterPack: ["innerPacksPerOuterPack", "inner_packs_per_outer_pack"],
  piecesPerOuterPack: ["piecesPerOuterPack", "pieces_per_outer_pack"],
  outerPacksPerPallet: ["outerPacksPerPallet", "outer_packs_per_pallet"],
  catchWeightFlag: ["catchWeightFlag", "catch_weight_flag"],
  inboundCatchData: ["inboundCatchData", "inbound_catch_data", "icdflag"],
  inboundSerialNo: ["inboundSerialNo", "inbound_serial_no", "inboundSerial", "icdlabel1"],
  inboundImei: ["inboundImei", "inbound_imei", "icdlabel2"],
  inboundOther3: ["inboundOther3", "inbound_other3", "inbound_other_3", "icdlabel3"],
  inboundOther4: ["inboundOther4", "inbound_other4", "inbound_other_4", "icdlabel4"],
  inboundOther5: ["inboundOther5", "inbound_other5", "inbound_other_5", "icdlabel5"],
  outboundCatchData: ["outboundCatchData", "outbound_catch_data", "ocdflag"],
  outboundSerialNo: ["outboundSerialNo", "outbound_serial_no", "outboundSerial", "ocdlabel1"],
  outboundImei: ["outboundImei", "outbound_imei", "ocdlabel2"],
  outboundOther3: ["outboundOther3", "outbound_other3", "outbound_other_3", "ocdlabel3"],
  outboundOther4: ["outboundOther4", "outbound_other4", "outbound_other_4", "ocdlabel4"],
  outboundOther5: ["outboundOther5", "outbound_other5", "outbound_other_5", "ocdlabel5"],
  uomConversionAllowed: ["uomConversionAllowed", "uom_conversion_allowed"],
  decimalAllowed: ["decimalAllowed", "decimal_allowed"],
  minOrderQty: ["minOrderQty", "min_order_qty"],
  maxOrderQty: ["maxOrderQty", "max_order_qty"],
  minReceiptQty: ["minReceiptQty", "min_receipt_qty"],
  packConfigVersion: ["packConfigVersion", "pack_config_version"],
  warehouseStorageType: ["warehouseStorageType", "warehouse_storage_type"],
  putawayStrategy: ["putawayStrategy", "putaway_strategy"],
  pickStrategy: ["pickStrategy", "pick_strategy"],
  batchControlled: ["batchControlled", "batch_controlled"],
  expiryControlled: ["expiryControlled", "expiry_controlled"],
  reorderSafetyFlag: ["reorderSafetyFlag", "reorder_safety_flag"],
  shelfLifeDays: ["shelfLifeDays", "shelf_life_days"],
  fragileFlag: ["fragileFlag", "fragile_flag"],
  qcRequired: ["qcRequired", "qc_required"],
  qcType: ["qcType", "qc_type"],
  inspectionTemplateId: ["inspectionTemplateId", "inspection_template_id"],
  defaultWarehouse: ["defaultWarehouse", "default_warehouse"],
  storageTemperatureRange: ["storageTemperatureRange", "storage_temperature_range"],
  stackLimit: ["stackLimit", "stack_limit"],
  weightPerUnit: ["weightPerUnit", "weight_per_unit"],
  volume: ["volume", "cube"],
  lengthDim: ["lengthDim", "length_dim", "length"],
  widthDim: ["widthDim", "width_dim", "width"],
  heightDim: ["heightDim", "height_dim", "height"],
  qcCertificateType: ["qcCertificateType", "qc_certificate_type"],
  returnableFlag: ["returnableFlag", "returnable_flag"],
  countryOfOrigin: ["countryOfOrigin", "country_of_origin", "country"],
  damageTolerance: ["damageTolerance", "damage_tolerance"],
  overReceiptTolerance: ["overReceiptTolerance", "over_receipt_tolerance"],
  underReceiptTolerance: ["underReceiptTolerance", "under_receipt_tolerance"],
  packagingVarianceTolerance: ["packagingVarianceTolerance", "packaging_variance_tolerance"],
  remarks: ["remarks", "notes"],
  createdOn: ["createdOn", "created_on", "createdAt"],
  updatedBy: ["updatedBy", "updated_by"],
  updatedOn: ["updatedOn", "updated_on", "updatedAt"],
  approvedBy: ["approvedBy", "approved_by"],
  approvedOn: ["approvedOn", "approved_on"],
  versionNumber: ["versionNumber", "version_number", "version"],
};

function toCamelCase(key) {
  return key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
}

function pickValue(source, keys) {
  for (const key of keys) {
    const value = source[key];
    if (value !== null && value !== undefined && value !== "") {
      return value;
    }
  }
  return undefined;
}

function isCheckedFlag(value) {
  if (value === true || value === 1) return true;
  const text = String(value ?? "").trim().toLowerCase();
  return text === "1" || text === "true" || text === "y" || text === "yes";
}

function coerceFormValue(formKey, value) {
  if (value === null || value === undefined) return undefined;
  if (formKey === "inboundCatchData" || formKey === "outboundCatchData") return isCheckedFlag(value);
  if (BOOL_FIELDS.has(formKey)) return !!value;
  if (typeof value === "number" && !Number.isNaN(value)) return String(value);
  if (typeof value === "boolean") return value;
  return value;
}

function isEmptyFormValue(value) {
  return value === "" || value === null || value === undefined;
}

export function flattenSkuApiRecord(record) {
  if (!record || typeof record !== "object") return {};

  const flat = {};

  const mergeObject = (obj) => {
    if (!obj || typeof obj !== "object" || Array.isArray(obj)) return;
    Object.entries(obj).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      flat[key] = value;
      if (key.includes("_")) {
        flat[toCamelCase(key)] = value;
      }
    });
  };

  mergeObject(record);

  if (typeof record.content === "string") {
    try {
      mergeObject(JSON.parse(record.content));
    } catch {
      // ignore invalid JSON content
    }
  } else {
    mergeObject(record.content);
  }

  NESTED_SOURCE_KEYS.forEach((key) => {
    const nested = record[key];
    if (Array.isArray(nested)) {
      nested.forEach((entry) => mergeObject(entry));
    } else {
      mergeObject(nested);
    }
  });

  return flat;
}

export function mapSkuRecordToFormState(record, createInitialFormState) {
  const flat = flattenSkuApiRecord(record);
  const mapped = createInitialFormState();

  Object.entries(FIELD_SOURCES).forEach(([formKey, sources]) => {
    const value = pickValue(flat, sources);
    if (value !== undefined) {
      mapped[formKey] = coerceFormValue(formKey, value);
    }
  });

  const resolvedUom =
    pickValue(flat, ["baseUom", "base_uom", "uom", "rfdefaultuom", "inventoryUom", "inventory_uom"]) || "";

  if (isEmptyFormValue(mapped.baseUom) && resolvedUom) mapped.baseUom = String(resolvedUom);
  if (isEmptyFormValue(mapped.inventoryUom) && resolvedUom) mapped.inventoryUom = String(resolvedUom);
  if (isEmptyFormValue(mapped.weightuom)) {
    mapped.weightuom = String(pickValue(flat, ["weightuom", "weightUom", "uom"]) || resolvedUom || "EA");
  }
  if (isEmptyFormValue(mapped.salesUom) && resolvedUom) mapped.salesUom = String(resolvedUom);

  for (let i = 1; i <= 12; i += 1) {
    const key = `lottable${i}`;
    const value = pickValue(flat, [key, `lottable_${i}`]);
    if (value !== undefined) mapped[key] = String(value);
  }

  Object.keys(mapped).forEach((key) => {
    if (!isEmptyFormValue(mapped[key])) return;
    if (flat[key] !== undefined && flat[key] !== null && flat[key] !== "") {
      mapped[key] = coerceFormValue(key, flat[key]);
    }
  });

  const weight = findWeightData(record);
  if (weight) {
    const label = (value) => (value === null || value === undefined ? "" : String(value));
    const num = (value) => (value === null || value === undefined || value === "" ? "" : String(value));
    mapped.weightData = weight;
    mapped.inboundCatchData = isCheckedFlag(weight.icdflag);
    mapped.inboundSerialNo = label(weight.icdlabel1);
    mapped.inboundImei = label(weight.icdlabel2);
    mapped.inboundOther3 = label(weight.icdlabel3);
    mapped.inboundOther4 = label(weight.icdlabel4);
    mapped.inboundOther5 = label(weight.icdlabel5);
    mapped.outboundCatchData = isCheckedFlag(weight.ocdflag);
    mapped.outboundSerialNo = label(weight.ocdlabel1);
    mapped.outboundImei = label(weight.ocdlabel2);
    mapped.outboundOther3 = label(weight.ocdlabel3);
    mapped.outboundOther4 = label(weight.ocdlabel4);
    mapped.outboundOther5 = label(weight.ocdlabel5);
    if (weight.avgcaseweight !== undefined && weight.avgcaseweight !== null) {
      mapped.inboundAvgCaseWeight = num(weight.avgcaseweight);
    }
    if (weight.oavgcaseweight !== undefined && weight.oavgcaseweight !== null) {
      mapped.outboundAvgCaseWeight = num(weight.oavgcaseweight);
    }
    if (weight.tolerancepct !== undefined && weight.tolerancepct !== null) {
      mapped.inboundTolerancePct = num(weight.tolerancepct);
    }
    if (weight.otolerancepct !== undefined && weight.otolerancepct !== null) {
      mapped.outboundTolerancePct = num(weight.otolerancepct);
    }
    if (weight.tareweight !== undefined && weight.tareweight !== null) {
      mapped.inboundTareWeight = num(weight.tareweight);
    }
    if (weight.otareweight !== undefined && weight.otareweight !== null) {
      mapped.outboundTareWeight = num(weight.otareweight);
    }
    if (String(weight.wgtuom || "").trim()) mapped.weightuom = String(weight.wgtuom);
    if (String(weight.ocdcatchwhen || "").trim()) mapped.catchWeightWhen = String(weight.ocdcatchwhen);
    if (weight.voicegroupingid !== undefined && weight.voicegroupingid !== null) {
      mapped.voiceGroupingId = num(weight.voicegroupingid);
    }
  }

  return mapped;
}

function parseMaybeJson(value) {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return value;
  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
}

function normalizeWeight(raw) {
  const value = parseMaybeJson(raw);
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const out = {};
  Object.entries(value).forEach(([key, entry]) => {
    out[String(key).replace(/_/g, "").toLowerCase()] = entry;
  });
  if (!("icdflag" in out) && !("ocdflag" in out)) return null;
  return out;
}

function findWeightData(node, depth = 0, seen = new Set()) {
  const value = parseMaybeJson(node);
  if (!value || typeof value !== "object" || depth > 8 || seen.has(value)) return null;
  seen.add(value);

  if (Array.isArray(value)) {
    for (const item of value) {
      const found = findWeightData(item, depth + 1, seen);
      if (found) return found;
    }
    return null;
  }

  const named = normalizeWeight(value.weightData ?? value.weight_data ?? value.WeightData);
  if (named) return named;

  for (const entry of Object.values(value)) {
    const found = findWeightData(entry, depth + 1, seen);
    if (found) return found;
  }
  return null;
}
